// ScenarioTable/ScenarioTableContext.js
import { createContext, useContext } from 'react';

export const ScenarioTableContext = createContext(null);

export const useScenarioTableContext = () => {
    const ctx = useContext(ScenarioTableContext);
    if (!ctx) {
        throw new Error(
            'useScenarioTableContext must be used inside ScenarioTableContext.Provider'
        );
    }
    return ctx;
};